import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FormatUnderlineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"format_underline"}/>
}
